import { Seo, softwareLd, breadcrumbLd } from "@/site/seo";
import { PLANS, FAQ } from "@/site/content";
import { Heading } from "@/site/components/Section";
import { PlanCards, WhereWeAre, FaqList } from "@/site/components/Pricing";
import LeadForm from "@/site/components/LeadForm";

export default function PricingPage() {
  const commercial = FAQ.filter((g) => g.group === "Commercial");
  return (
    <>
      <Seo title="Pricing" description="Postern pricing: one plan, every feature included. $500 a month covers your first 8 seats, then $50 per additional seat, billed monthly." jsonLd={[softwareLd(PLANS), breadcrumbLd([{ name: "Home", path: "/" }, { name: "Pricing", path: "/pricing" }])]} />
      <section className="section dotgrid">
        <div className="wrap">
          <Heading eyebrow="Pricing" title="One plan. Everything included." lede="Every seat gets the whole product — whitespace, CPQ, approvals, legal review and forecasting. No per-deal fees, no payment processing margin — Postern never touches the money." />
          <PlanCards />
        </div>
      </section>
      <section className="section section--paper section--tight">
        <div className="wrap">
          <WhereWeAre />
        </div>
      </section>
      <section className="section">
        <div className="wrap" style={{ maxWidth: 860 }}>
          <Heading eyebrow="Commercial questions" title="Terms, billing, cancellation." />
          <FaqList groups={commercial} />
        </div>
      </section>
      <section className="section cta-band" id="pilot">
        <div className="wrap cta-band__grid">
          <div><div className="eyebrow" style={{ color: "#d9b45b" }}>Start a pilot</div><h2 className="h2">See the price against your real book.</h2><p className="lede">Send your account list; the first session prices a real deal.</p></div>
          <LeadForm source="pricing" />
        </div>
      </section>
    </>
  );
}
